/* ═══════════════════════════════════════════════════════════════════════════
   Labels — pure display-label helpers for booking extras and sources.
   Stored values may be in either language; these translate at render time.
   Extracted from App.jsx (2026-05-29); see
   docs/superpowers/specs/2026-05-29-app-jsx-decomposition-design.md
   ═══════════════════════════════════════════════════════════════════════════ */

// Legacy keys → labels for historical bookings that pre-date per-property extras.
// Safe to remove once verified no bookings store these keys anymore.
const LEGACY_EXTRAS_LABELS = {
  babyCot:         { en: "Baby cot",         bg: "Кошара" },
  sofa:            { en: "Sofa bed",         bg: "Диван" },
  specialOccasion: { en: "Special occasion", bg: "Специален повод" },
};
function extraLabel(extra, lang) {
  if (!extra) return "";
  if (typeof extra === "string") {
    const legacy = LEGACY_EXTRAS_LABELS[extra];
    if (legacy) return legacy[lang] || legacy.en;
    return extra; // already a plain label string
  }
  return extra[lang] || extra.en || extra.bg || "";
}

// Sources are stored in whichever language the booking was created in (see SRC_BG /
// SRC_EN), so we need to translate at display time. Booking.com / Facebook /
// Instagram are brand names and stay as-is.
const SOURCE_DISPLAY = {
  'Direct':    { en: 'Direct',    bg: 'Директно' },
  'Директно':  { en: 'Direct',    bg: 'Директно' },
  'Phone':     { en: 'Phone',     bg: 'Телефон'  },
  'Телефон':   { en: 'Phone',     bg: 'Телефон'  },
  'Other':     { en: 'Other',     bg: 'Друго'    },
  'Друго':     { en: 'Other',     bg: 'Друго'    },
};
function displaySource(source, lang) {
  if (!source) return '';
  const map = SOURCE_DISPLAY[source];
  if (!map) return source;
  return map[lang] || map.en;
}

function isSofaBedExtra(extra) {
  if (!extra) return false;
  const text = (typeof extra === 'object'
    ? (extra.en || '') + ' ' + (extra.bg || '')
    : ((LEGACY_EXTRAS_LABELS[extra]?.en || '') + ' ' + (LEGACY_EXTRAS_LABELS[extra]?.bg || '') + ' ' + extra)
  ).toLowerCase();
  return text.includes('sofa') || text.includes('диван');
}
function isCotExtra(extra) {
  if (!extra) return false;
  const text = (typeof extra === 'object'
    ? (extra.en || '') + ' ' + (extra.bg || '')
    : ((LEGACY_EXTRAS_LABELS[extra]?.en || '') + ' ' + (LEGACY_EXTRAS_LABELS[extra]?.bg || '') + ' ' + extra)
  ).toLowerCase();
  return text.includes('cot') || text.includes('кошара') || text.includes('baby');
}
function isOccasionExtra(extra) {
  if (!extra) return false;
  const text = (typeof extra === 'object'
    ? (extra.en || '') + ' ' + (extra.bg || '')
    : ((LEGACY_EXTRAS_LABELS[extra]?.en || '') + ' ' + (LEGACY_EXTRAS_LABELS[extra]?.bg || '') + ' ' + extra)
  ).toLowerCase();
  return text.includes('occasion') || text.includes('повод') || text.includes('decoration');
}

export { extraLabel, displaySource, isSofaBedExtra, isCotExtra, isOccasionExtra };
